var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { x } from '@imtbl/sdk';
import { ethers } from 'ethers';
import { useContext, useState } from 'react';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import { DialogType } from '../../types/dialogs';
import { useMetamask } from './use-metamask';
export function useCustomWallet() {
    var t = useI18n().t;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _a = useContext(UserContext), user = _a.user, reconnectUser = _a.reconnectUser, setSelectedWallet = _a.setSelectedWallet;
    var _b = useState(undefined), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = useState(false), customWalletNewlyLinked = _c[0], setCustomWalletNewlyLinked = _c[1];
    var _d = useMetamask(false, 'eth'), connectMetamask = _d.connectMetamask, metamaskWalletAddress = _d.metamaskWalletAddress, metamaskErrorMessage = _d.metamaskErrorMessage, metamaskConnected = _d.metamaskConnected, setMetamaskErrorMessage = _d.setMetamaskErrorMessage, personalSignMessage = _d.personalSignMessage;
    function linkCustomWallet() {
        return __awaiter(this, void 0, void 0, function () {
            var provider, ethSigner, starkPrivateKey, starkSigner, imxProvider, _err_1, nonce, signedNonce, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setErrorMessage('');
                        if (!user || user.coldWalletAddress || !metamaskConnected || !metamaskWalletAddress || !window.ethereum)
                            return [2 /*return*/];
                        setServerLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 12, 13, 14]);
                        provider = new ethers.BrowserProvider(window.ethereum);
                        return [4 /*yield*/, provider.getSigner()];
                    case 2:
                        ethSigner = _a.sent();
                        return [4 /*yield*/, x.generateLegacyStarkPrivateKey(ethSigner)];
                    case 3:
                        starkPrivateKey = _a.sent();
                        starkSigner = x.createStarkSigner(starkPrivateKey);
                        imxProvider = new x.GenericIMXProvider(new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }), ethSigner, starkSigner);
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, imxProvider.registerOffchain()];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        _err_1 = _a.sent();
                        setErrorMessage(t('error.custom-wallet.failed-to-register'));
                        return [2 /*return*/];
                    case 7: return [4 /*yield*/, gqlSdk.UserInitiateColdWalletLink({
                            input: { coldWalletAddress: metamaskWalletAddress },
                        })];
                    case 8:
                        nonce = (_a.sent()).userInitiateColdWalletLink;
                        return [4 /*yield*/, personalSignMessage(metamaskWalletAddress, nonce.nonce)];
                    case 9:
                        signedNonce = _a.sent();
                        return [4 /*yield*/, gqlSdk.UserCompleteColdWalletLink({
                                input: { signedNonce: signedNonce },
                            })];
                    case 10:
                        _a.sent();
                        setCustomWalletNewlyLinked(true);
                        return [4 /*yield*/, reconnectUser()];
                    case 11:
                        _a.sent();
                        setSelectedWallet((user === null || user === void 0 ? void 0 : user.coldWalletAddress) || undefined);
                        return [3 /*break*/, 14];
                    case 12:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            console.log(err_1.message);
                            setErrorMessage(t('error.custom-wallet.failed-to-link'));
                        }
                        return [3 /*break*/, 14];
                    case 13:
                        setServerLoading(false);
                        return [7 /*endfinally*/];
                    case 14: return [2 /*return*/];
                }
            });
        });
    }
    function closeDialog() {
        setMetamaskErrorMessage(undefined);
        setDialogProps(undefined);
    }
    function showCustomWalletUnlinkDialog() {
        setDialogProps({
            common: {
                title: t('common.unlink'),
                close: { text: t('common.back'), action: closeDialog },
                actions: [{ text: t('common.confirm'), action: unlinkCustomWallet, highlighted: true }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('account.wallets.custom-wallet.unlink.confirm-message'),
            },
        });
    }
    function unlinkCustomWallet() {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setErrorMessage('');
                        if (!user)
                            return [2 /*return*/];
                        if (!user.coldWalletAddress)
                            return [2 /*return*/];
                        setServerLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, gqlSdk.UserUnsetColdWallet({})];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, reconnectUser()];
                    case 3:
                        _b.sent();
                        setDialogProps({
                            common: {
                                title: t('common.success'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: t('account.wallets.custom-wallet.unlink.success-message'),
                            },
                        });
                        return [3 /*break*/, 6];
                    case 4:
                        _a = _b.sent();
                        setDialogProps({
                            common: {
                                title: t('common.unlink'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: t('error.custom-wallet.failed-to-unset'),
                            },
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        setServerLoading(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function globalSetErrorMessage(value) {
        setMetamaskErrorMessage(value);
        setErrorMessage(value);
    }
    return {
        linkCustomWallet: linkCustomWallet,
        unlinkCustomWallet: unlinkCustomWallet,
        showCustomWalletUnlinkDialog: showCustomWalletUnlinkDialog,
        connectMetamask: connectMetamask,
        metamaskWalletAddress: metamaskWalletAddress,
        errorMessage: errorMessage || metamaskErrorMessage,
        setErrorMessage: globalSetErrorMessage,
        metamaskConnected: metamaskConnected,
        customWalletNewlyLinked: customWalletNewlyLinked,
    };
}
